module.exports = __webpack_public_path__ + "static/gender_card_img4@2x-df4d247db5dfada3f805344975231104.jpg";